import { render, staticRenderFns } from "./MintalMesQualityProductionProjectList.vue?vue&type=template&id=23e197aa&"
import script from "./MintalMesQualityProductionProjectList.vue?vue&type=script&lang=js&"
export * from "./MintalMesQualityProductionProjectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports